import { setStorage, getStorage } from "@/storage/index.js";
import { sign } from "@/util/sign.js"
import axios from 'axios';
export const mixinTable = {
  data() {
    return {
      token: getStorage('token'),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      selLoading: false,
      companyArr: [], // 企业主体
      employeeArr: [],// 员工
      employeeAllArr: [],// 所有员工
      roleArr: [], // 角色
      organizeArr: [], // 部门架构
      approvalTypeArr: [], // 审批类型
      purchaseTypeArr: [], //采购类型
      leaveTypeArr: [], //请假类型
      approvalArr: [], //审批表单列表
      btn_permissions: {}, // 按钮权限
      approvalOpt: [],//发起审批，审批表单列表
      channelCopy: [],
      resultOpt: [
        {id:1,name:'正常'},
        {id:2,name:'早退'},
        {id:3,name:'迟到'},
        {id:4,name:'缺卡'},
        {id:5,name:'请假'},
        {id:6,name:'休息'},
        {id:7,name:'外勤'},
        {id:8,name:'旷工'},
      ],
    }
  },
  created() {
    this.btn_permissions = getStorage('btn_permissions');
  },
  methods: {
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields()
      this.table.params.page = 1;
      this.getTable();
    },
    // 查询时默认第一页
    onSearch() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.params.count = 10;
      this.table.data = [];
      this.getTable();
    },
    // pageSize 改变时会触发
    handleSizeChange(pageSize) {
      this.table.params.count = pageSize;
      this.table.params.page = 1;
      this.getTable();
    },
    //页面改变时触发
    handleCurrentChange(page) {
      this.table.params.page = page;
      this.getTable();
    },
    // 字段转义
    toStr(data, key) {
      return data[key]
    },
    // 确认提示框
    setConfirm(str, data, url) {
      this.$confirm(str, "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false, // MessageBox 是否显示右上角关闭按钮
        closeOnClickModal: false, // 是否可通过点击遮罩关闭 MessageBox
        closeOnPressEscape: false, // 是否可通过按下 ESC 键关闭 MessageBox
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
             instance.confirmButtonText = '执行中...';
            instance.showCancelButton = false; // 是否显示取消按钮
            this.$http.post(url, data).then(res => {
              if(res.code == 1) {
                this.$message.success('操作成功！')
                this.getTable();
                done()
              }
            }).finally(() => {
              instance.confirmButtonLoading = false;
              instance.showCancelButton =  true;
              done()
            })
          } else {
            done()
          }
        }
      }).catch(() => {})
    },

    // 获取路由
    getRouter() {
      this.$http.get("/admin/role/permissions", { params: {} }).then((res) => {
        if (res.code == 1) {
          let routerArr = res.data.access_list.map((v) => {
            return {
              path: v.web_path,
              name:
                v.web_path.substring(2).charAt(0).toUpperCase() +
                v.web_path.slice(1),
              meta: { title: v.name },
              children: v.child.map((j) => {
                return {
                  path: j.web_path,
                  name:
                    j.web_path.substring(2).charAt(0).toUpperCase() +
                    j.web_path.slice(1),
                  meta: { title: j.name },
                };
              }),
            };
          });
          setStorage("router", routerArr);
          setStorage("btn_permissions", res.data.permissions);
        }
      });
    },
    convertToUpperCase(amount) {
      // 处理非数字输入
  if (isNaN(amount)) {return ''}
  
  // 数字映射
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  // 单位分级（元/万/亿 + 个/十/百/千）
  const units = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
  // 小数单位
  const fractions = ['角', '分'];

  // 处理符号
  let prefix = amount < 0 ? '负' : '';
  amount = Math.abs(Number(amount));

  // 处理小数部分（精确到分）
  let decimalStr = '';
  const cents = Math.round(amount * 100) % 100;
  if (cents > 0) {
    const jiao = Math.floor(cents / 10);
    const fen = cents % 10;
    decimalStr = (jiao > 0 ? digit[jiao] + fractions[0] : '') + 
                 (fen > 0 ? digit[fen] + fractions[1] : '');
  }

  // 处理整数部分
  let integer = Math.floor(amount);
  let integerStr = integer === 0 ? '零' : '';
  
  for (let i = 0; i < units[0].length && integer > 0; i++) {
    let groupStr = '';
    for (let j = 0; j < units[1].length && integer > 0; j++) {
      const num = integer % 10;
      groupStr = (num > 0 ? digit[num] + units[1][j] : '零') + groupStr;
      integer = Math.floor(integer / 10);
    }
    // 处理组内连续零和末尾零
    groupStr = groupStr.replace(/零+/g, '零').replace(/零$/, '');
    if (groupStr) {
      integerStr = groupStr + units[0][i] + integerStr;
    }
  }

  // 合并结果并清理冗余零
  let result = prefix + 
               integerStr.replace(/零+/g, '零')
                         .replace(/零元/, '元')
                         .replace(/零$/, '') +
               (decimalStr || '整');

  // 特殊处理零金额
  if (result === '整') result = '零元整';

  return result;
    },
    // 查询所有企业主体列表(filter_department:过滤是否已绑定部门：0-不限制；1-过滤)
    getCompanyAll() {
      this.$http.get('/admin/company/all',{params:{name:'',filter_department:0}}).then(res => {
        if(res.code == 1) {
          this.companyArr = res.data;
        }
      })
    },
    // 获取所有角色列表
    getRoleAll() {
      this.$http.get('/admin/role/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.roleArr = res.data;
        }
      })
    },
    // 获取所有部门
    getOrganizeAll() {
      this.$http.get('/admin/department/all',{params: {}}).then(res => {
        if(res.code == 1) {
          this.organizeArr = res.data;
        }
      })
    },
    // 获取所有审批类别
    getApprovalTypeAll() {
      this.$http.get('/admin/ApprovalType/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.approvalTypeArr = res.data;
        }
      })
    },
    // 获取所有采购类别
    getPurchaseTypeAll() {
      this.$http.get('/admin/PurchaseType/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.purchaseTypeArr = res.data;
        }
      })
    },
    // 获取所有请假类型
    getLeaveTypeAll() {
      this.$http.get('/admin/LeaveType/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.leaveTypeArr = res.data;
        }
      })
    },
    // 获取所有员工列表(status状态：1-在职；2-离职；show_department:是否展示部门信息：1-展示；0-不展示；)
    getEmployeeAll() {
      this.$http.get('/admin/employee/all',{params:{status:1,show_department:1}}).then(res => {
        if(res.code == 1) {
          this.employeeAllArr = res.data.list;
          this.channelCopy = res.data.list;
        }
      })
    },
    // 获取所有审批表单列表
    getApprovalAll() {
      this.$http.get('/admin/approval/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.approvalArr = res.data;
        }
      })
    },
    // 搜索在职员工
    employeeRemoteMethod(query) {
      if(query !== '') {
        let _params = {
          page: 1,
          count: 1000,
          status:1,   //状态：1-在职；2-离职；
          show_department:1, //是否展示部门信息：1-展示；0-不展示；
          keyword: query,
        }
        this.selLoading = true;
        this.$http.get('/admin/employee/all', { params: _params}).then(res => {
          if(res.code === 1) {
            this.employeeArr = res.data.list;
          }
        }).finally(() => {
          this.selLoading = false;
        })
      } else {
        this.employeeArr = [];
      }
    },
    // 搜索审批表单
    approvalRemoteMethod(query) {
      if(query !== '') {
        let _params = {
          page: 1,
          count: 100,
          name: query,
        }
        this.selLoading = true;
        this.$http.get('/admin/approval/my', { params: _params}).then(res => {
          if(res.code === 1) {
             // 取二级数组组成一个新数组
            this.approvalOpt =  res.data.list.reduce((acc, item) => acc.concat(item.approvals), []);
          }
        }).finally(() => {
          this.selLoading = false;
        })
      } else {
        this.approvalOpt = [];
      }
    },
   
    // 全部导出
    exportData(obj,url) {
      obj.timestamp = new Date().getTime();
      obj.token = localStorage.getItem('token');
      let str = '';
      Object.keys(obj).forEach((item)=>{
        str += `&${item}=${obj[item]}`
      })
      let data = sign(obj);
      let _baerUrl = process.env.VUE_APP_BASE_API
      console.log(`${_baerUrl}${url}?sign=${data}${str}`,3)
      window.open(`${_baerUrl}${url}?sign=${data}${str}`)
    },
    // 下载文件
    async downloadFile(urls,name) {
      const response = await axios({
        url: urls,
        method: 'GET',
        responseType: 'blob', // 必须指定为blob类型才能下载
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}`);
      document.body.appendChild(link);
      link.click();
    },
    getprojectAll() {
      this.$http.get('/admin/project/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.projectArr = res.data;
        }
      })
    },
    //费用查所有
    getexpenseAll() {
      this.$http.get('/admin/CostType/all',{params:{}}).then(res => {
        if(res.code == 1) {
          this.CostTypeArr = res.data;
        }
      })
    },
  }
}